// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"a57d02b0e915ca81f090","293":"f20c8724453aad8c1d5e","518":"8d052e83dd73b9a5162d","779":"d8dbc8d644a712ed8e5c"}[chunkId] + ".js";
};